import { gql } from '@apollo/client';

export interface DeleteCarpoolTripMutation {
  deleteCarpoolTrip: {
    id: string;
  };
}

export interface DeleteCarpoolTripMutationVariables {
  tripId: string;
}

export const DELETE_CARPOOL_TRIP = gql`
  mutation DeleteCarpoolTrip($tripId: ID!) {
    deleteCarpoolTrip(tripId: $tripId) {
      id
    }
  }
`;
